var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tag",style:({'--total-height': _vm.height + 'rem'}),attrs:{"id":"tag"}},[_c('div',{attrs:{"id":"circle"}},[_c('Star',{ref:"star",staticClass:"star"})],1),_c('div',{ref:"score",class:{'cursor-pointer': _vm.isExchangable},attrs:{"id":"score"},on:{"click":_vm.exchange}},[_vm._v(" "+_vm._s(_vm.display_score)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }